// Set COE menu variable
const coeMenu = document.querySelector('.coe-menu');
const coeMenuToggle = document.querySelectorAll('.coe-menu__toggle');
const coeMenuChildren = document.querySelectorAll('.coe-menu__children');
const coeButton = document.querySelector('.button--main-menu');
const coeHasDropdown = document.querySelectorAll('.coe-menu__items .coe-menu__item--has-dropdown');
const searchButton = document.querySelector('.header-bar__ctas .button--search');

function setDropdownState(toggle, panel, isOpen) {
  toggle.classList.toggle('js-open', isOpen);
  panel.classList.toggle('js-open', isOpen);
  toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
}

// Show/hide COE menu based on click and window size
function clickDropdowns() {
  coeMenuToggle.forEach((e) => {
    const nextSibling = e.nextElementSibling;
  
    e.addEventListener('click', () => {
      // Find sibling `coe-menu__children` element
      if (e.classList.contains('js-open')) {
        setDropdownState(e, nextSibling, false);
      } else {
        resetMenuToggles();
        setDropdownState(e, nextSibling, true);

        // ADA: move focus into the opened dropdown panel (desktop)
        if (window.innerWidth > 900) {
          const firstFocusable = nextSibling.querySelector(
            'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          if (firstFocusable) {
            firstFocusable.focus();
          }
        }
      }

      // Set offscreen classes on click
      setTimeout(() => {
        // Get dropdown dimensions relative to the viewport
        const dropdownBounds = nextSibling.getBoundingClientRect();
        const dropdownRightSide = dropdownBounds.x + dropdownBounds.width + 45;

        // Check if dropdown element displays outside of the viewport
        if (dropdownBounds.x < 0 && window.innerWidth > 900) {
          nextSibling.classList.add('js-offscreen-left');
          e.parentElement.classList.add('js-offscreen-child');
        } else if (dropdownRightSide > window.innerWidth && window.innerWidth > 900) {
          nextSibling.classList.add('js-offscreen-right');
          e.parentElement.classList.add('js-offscreen-child');
        }
      }, '5');
    });

    // A pointer interaction on the toggle or inside the panel must not trigger
    // the focusout-close. `relatedTarget` is unreliable here: Firefox/Safari do
    // not focus a <button> on click, so a toggle click would otherwise blur the
    // panel to <body>, close via focusout, and the click handler would reopen.
    // Set a flag on pointerdown (auto-reset next tick) and let the click handler
    // own pointer-driven closing. `pointerdown` fires before the focus change
    // for mouse, pen, and touch (mousedown is synthesized too late on touch).
    let pointerWithin = false;
    const flagPointerWithin = () => {
      pointerWithin = true;
      setTimeout(() => { pointerWithin = false; }, 0);
    };
    e.addEventListener('pointerdown', flagPointerWithin);
    nextSibling.addEventListener('pointerdown', flagPointerWithin);

    // Close the dropdown when keyboard focus leaves the panel entirely
    // (registered once). Skip when focus moves to the toggle itself.
    nextSibling.addEventListener('focusout', (event) => {
      if (pointerWithin) {
        return;
      }
      if (!nextSibling.contains(event.relatedTarget) && event.relatedTarget !== e) {
        setDropdownState(e, nextSibling, false);
      }
    });

    // On `esc` press hide open dropdown
    document.addEventListener('keyup', (k) => {
      if (nextSibling.classList.contains('js-open')) {
        const key = k.key;
        if (key === 'Escape' || key === 'Esc' || key === 27) {
          setDropdownState(e, nextSibling, false);
        }
      }
    });
  });
}

// Show/hide COE menu based on hover and window size
function hoverDropdowns() {
  coeHasDropdown.forEach((e) => {
    if (window.innerWidth > 900) {
      e.addEventListener('mouseover', () => {
        e.classList.add('js-hover');

        // Get dropdown dimensions relative to the viewport
        const dropdownBounds = e.children[2].getBoundingClientRect();
        const dropdownRightSide = dropdownBounds.x + dropdownBounds.width + 45;

        // Check if dropdown element displays outside of the viewport
        if (dropdownBounds.x < 0) {
          e.children[2].classList.add('js-offscreen-left');
          e.classList.add('js-offscreen-child');
        } else if (dropdownRightSide > window.innerWidth) {
          e.children[2].classList.add('js-offscreen-right');
          e.classList.add('js-offscreen-child');
        }
      });
    
      e.addEventListener('mouseout', () => {
        e.classList.remove('js-hover');
        e.children[2].classList.remove('js-offscreen-left', 'js-offscreen-right');
        e.classList.remove('js-offscreen-child');
      });
    } else {
      // Ensure classes are removed when interactiing with menu items below 900
      e.addEventListener('mouseover', () => {
        e.classList.remove('js-hover');
      });
    }
  });
}

// Show/hide COE menu based on window size
function displayCoeMenu() {
  if (window.innerWidth > 900) {
    // Show COE menu
    coeMenu.hidden = false;
    coeMenu.classList.remove('menu-is-open');
  } else {
    // Hide COE menu if menu is open
    if (!coeButton.classList.contains('menu-is-open')) {
      coeMenu.hidden = true;
    }
  }
}

// Reset menu toggles
function resetMenuToggles() {
  coeMenuToggle.forEach((e) => {
    const nextSibling = e.nextElementSibling;
    setDropdownState(e, nextSibling, false);
  });
}

if (coeMenu) {
  const coeLabel = document.getElementsByClassName('coe-title__link')[0].innerHTML;

  // Initialize priority nav
  const nav = priorityNav.init({
    mainNavWrapper: '.coe-menu__nav', // mainnav wrapper selector (must be direct parent from mainNav)
    mainNav: '.coe-menu__items', // mainnav selector. (must be inline-block)
    navDropdownLabel: dictionary.More,
    navDropdownBreakpointLabel: `${coeLabel} Navigation`,
    navDropdownClassName: 'coe-menu__dropdown', // class used for the dropdown.
    navDropdownToggleClassName: 'coe-menu__dropdown-toggle', // class used for the dropdown toggle.
    breakPoint: 900,
    throttleDelay: 50,
  });

  // Show/hide COE menu on page load
  displayCoeMenu();
  hoverDropdowns();
  clickDropdowns();

  // Show/hide COE menu on resize
  window.addEventListener('resize', () => {
    displayCoeMenu();
    hoverDropdowns();
  });

  // Toggle COE menu on button toggle
  if (coeButton) {
    coeButton.addEventListener('click', () => {
      if (coeMenu.hidden === true) {
        coeMenu.hidden = false;
        coeMenu.classList.add('menu-is-open');

        // ADA: move focus into the menu (first focusable link/control)
        const firstFocusable = coeMenu.querySelector(
          'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (firstFocusable) {
          firstFocusable.focus();
        }
      } else {
        coeMenu.hidden = true;
        coeMenu.classList.remove('menu-is-open');
      }
    });
  }

  const moreButton = document.querySelector('.coe-menu__dropdown-wrapper');

  if (moreButton) {
    moreButton.addEventListener('mouseover', () => {
      moreButton.classList.add('js-hover');
    });

    moreButton.addEventListener('mouseout', () => {
      moreButton.classList.remove('js-hover');
    });
  }
}

if (searchButton) {
  // Close COE menu on search button click
  searchButton.addEventListener('click', () => {
    if (window.innerWidth < 900) {
      // Hide COE menu
      coeMenu.hidden = true;
      coeMenu.classList.remove('menu-is-open');
    }
  });
}